import { EditType } from 'types';
import { SearchWorkerResult } from 'components/searchBox/types';
import type {
  EditableFormSubmissionWorker,
  EditableEnhancedFormSubmissionWorker,
  FormSubmissionWorkerAssociationType,
  OnFormSubmissionWorkerConfirmed,
} from 'containers/jobsiteFormSubmission/types';

export type OnWorkerConfirmed =
  OnFormSubmissionWorkerConfirmed<EditableEnhancedFormSubmissionWorker>;

export type JobsiteFormSubmissionWorkerEdit =
  EditableEnhancedFormSubmissionWorker & {
    editType: EditType;
    searchWorkerResult: SearchWorkerResult;
  };

/**
 * - `edit` (default): a worker's details (Jobsite, Role(s) in Incident) are set
 *   when adding them and can be edited by clicking their card.
 * - `add`: a picked worker is added as is and the modal closes; cards only allow removal.
 * - `addMany`: like `add`, but the modal stays open so several workers can be added in one go.
 */
export type FormSubmissionWorkersMode = 'edit' | 'add' | 'addMany';

export type FormSubmissionWorkersProps = {
  jobsiteFormSubmissionId?: string;
  associationType?: FormSubmissionWorkerAssociationType;
  value?: EditableFormSubmissionWorker[];
  onChange?: (value: EditableFormSubmissionWorker[]) => void;
  mode?: FormSubmissionWorkersMode;
  /** Lists workers in the picker before anything is typed (default `true`); `false` waits for a search term. */
  showInitialSearchResults?: boolean;
};

export enum ParticipantType {
  Injured = 'Injured',
  Other = 'Other',
  Responsible = 'Responsible',
  Suspected = 'Suspected',
  Witness = 'Witness',
}
